export const isMobile = (): boolean => {
  const userAgent = navigator.userAgent.toLowerCase();
  const isMobile = /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/.test(userAgent);
  return isMobile;
};

export const isIOS = () => /iPad|iPhone|iPod/.test(navigator.userAgent);
